<template>
  <el-popover
    v-if="show && tableColumnsMap && displayColumns"
    placement="bottom-end"
    width="200"
    trigger="click"
  >
    <p
      slot="reference"
      style="color: #0c6fff; font-size: 14px"
      class="cursor-pointer flex items-center"
    >
      <el-tooltip
        class="item"
        effect="dark"
        content="自定义表头"
        placement="top-start"
      >
        <img :src="iconShezhi" class="mr-1" style="margin-top: 2px" />
      </el-tooltip>
    </p>
    <div class="custom-table-header-popover">
      <el-checkbox
        v-model="allColumnsSelected"
        :disabled="allColumnsSelected"
        :indeterminate="allColumnsSelectedIndeterminate"
        @change="handleCheckAllChange"
      >
        全选
      </el-checkbox>
      <template v-for="(item, index) in displayColumns">
        <el-checkbox
          v-if="
            index < displayColumns.length - 1 || (item.label !== '操作' && !item.disable)
          "
          :key="item.label"
          v-model="item.visible"
          v-dragging="{ item: item, list: displayColumns, group: keys || 'item' }"
          :disabled="item.disable"
          @change="handleCheckedTableColumnsChange(item)"
        >
          <div class="labelItem">{{ item.label }}</div>
        </el-checkbox>
      </template>
      <el-checkbox
        v-if="
          displayColumns.length &&
          (displayColumns[displayColumns.length - 1].label === '操作' ||
            displayColumns[displayColumns.length - 1].disable)
        "
        v-model="displayColumns[displayColumns.length - 1].visible"
        :disabled="displayColumns[displayColumns.length - 1].disable"
        >{{ displayColumns[displayColumns.length - 1].label }}</el-checkbox
      >
    </div>
    <el-button
      v-permission="[permissionColumnsKey, permsList]"
      type="primary"
      size="mini"
      @click="handleSave"
    >
      设置为机构模板
    </el-button>
  </el-popover>
</template>
<script>
import iconShezhi from '@/assets/svg/videoManga/shezhi_icon.svg'
import { mapGetters } from 'vuex'
import { saveTableColumns, getTableColumns } from '@/api/global'
import { setColumns } from '@/utils/tableUtils'

export default {
  props: {
    keys: {
      type: String,
      default: ''
    },
    onType: {
      type: String,
      default: 'dragged'
    },
    permissionColumnsKey: {
      type: String,
      default: ''
    },
    // 当前表格的完整列定义（由表格组件合并后的 initColumns 传入），
    // 作为与已保存配置合并的基准，保证弹框始终包含表格的所有列
    columns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['tableColumnsMap', 'userInfo'])
  },
  data() {
    return {
      // 弹框实际渲染的列（完整列与已保存配置合并后的结果）
      displayColumns: [],
      // 后端已保存的列配置缓存，父级完整列变化时用于重新合并
      savedFields: null,
      permsList: this?.$route?.meta?.permsList || [],
      show: false,
      allColumnsSelected: false,
      allColumnsSelectedIndeterminate: false,
      iconShezhi
    }
  },
  watch: {
    // 父级传入的完整列变化时，用已缓存的保存配置重新合并（修复新增列不进弹框的问题）
    columns: {
      handler() {
        this.mergeColumns()
      },
      deep: true
    },
    displayColumns: {
      handler(val) {
        const arr = val?.filter(v => v.visible) ?? []
        this.allColumnsSelected = arr.length === this.displayColumns.length
        this.show = true
      },
      deep: true,
      immediate: true
    }
  },
  activated() {
    this.init()
  },
  deactivated() {
    this.show = false
  },
  beforeDestroy() {
    this.show = false
  },
  destroyed() {
    this.show = false
  },
  created() {
    this.init()
  },
  mounted() {
    this.show = true
    // 拖拽后触发的事件
    this.$nextTick(() => {
      setTimeout(() => {
        this.$dragging.$on('dragend', async res => {
          // 只响应当前组件的拖拽事件，防止影响其他页面的同名列表
          if (res.group === (this.keys || 'item')) {
            this.saveLocalFields()
            await this.saveTableColumns(2)
            this.$emit('change', this.displayColumns)
          }
        })
      })
    })
  },
  methods: {
    init() {
      this.show = true
      if (this.keys) {
        this.getTableColumns()
      } else {
        this.mergeColumns()
      }
    },
    // 完整列来源：优先父级传入的 columns，其次 vuex 中表格组件合并后的列
    getFullColumns() {
      if (this.columns && this.columns.length) {
        return this.columns
      }
      return this.tableColumnsMap[this.keys] || []
    },
    // 将已保存配置与当前完整列合并：保留已存的顺序与显隐，
    // 后新增的列按默认配置中的位置插入，操作列固定在最后。
    // 叠加状态优先取当前弹框列（反映用户刚操作的显隐/顺序），
    // 避免父级重新计算完整列时用旧的 savedFields 覆盖用户刚做的勾选
    mergeColumns() {
      const full = this.getFullColumns()
      const overlay = (this.displayColumns && this.displayColumns.length)
        ? this.displayColumns
        : this.savedFields
      this.displayColumns = (overlay && overlay.length) ? setColumns(full, overlay) : full
    },
    async getTableColumns() {
      // 优先读浏览器本地缓存（用户最近一次的个人配置），
      // 避免切换 tab / 刷新页面后被后端空配置覆盖
      const localFields = this.getLocalFields()
      if (localFields) {
        this.savedFields = localFields
        this.mergeColumns()
        this.$emit('change', this.displayColumns)
        return
      }
      try {
        const { code, data } = await getTableColumns({
          listCode: this.keys
        })
        if (code === 1 && data.displayFields) {
          const list = JSON.parse(data.displayFields)
          this.savedFields = list && list.length ? list : null
        } else {
          this.savedFields = null
        }
      } catch {
        this.savedFields = null
      }
      this.mergeColumns()
      this.$emit('change', this.displayColumns)
    },

    // localStorage 键：按 机构 + 用户 + 表格 keys 隔离，避免串号/串机构
    getStorageKey() {
      const orgId = this.userInfo?.organizationId || ''
      const userId = this.userInfo?.userId || this.userInfo?.id || ''
      return `custom_table_columns:${orgId}:${userId}:${this.keys}`
    },
    getLocalFields() {
      if (!this.keys) return null
      try {
        const raw = localStorage.getItem(this.getStorageKey())
        const list = raw ? JSON.parse(raw) : null
        return list && list.length ? list : null
      } catch {
        return null
      }
    },
    saveLocalFields() {
      if (!this.keys || !this.displayColumns.length) return
      try {
        localStorage.setItem(
          this.getStorageKey(),
          JSON.stringify(this.displayColumns)
        )
      } catch {}
    },

    async saveTableColumns(levelType) {
      try {
        // 无 keys 的页面（如直播数据看板）只做本地显隐，不保存到后端
        if (!this.keys || !this.displayColumns.length) return
        await saveTableColumns({
          listCode: this.keys,
          displayFields: JSON.stringify(this.displayColumns),
          levelType: levelType
        })
      } catch {}
    },
    async handleCheckedTableColumnsChange(item) {
      const arr = this.displayColumns.filter(v => v.visible)
      this.allColumnsSelected = arr.length === this.displayColumns.length
      if (arr.length === 0) {
        item.visible = true
        this.$message.error('最少保留一条')
      }
      this.saveLocalFields()
      await this.saveTableColumns(2)
      this.$emit('change', this.displayColumns)
    },
    async handleSave() {
      this.saveLocalFields()
      await this.saveTableColumns(1)
      this.$message.success('保存成功')
    },
    // 表头选择全部
    async handleCheckAllChange(val) {
      this.displayColumns.map(v => {
        v.visible = true
      })
      this.saveLocalFields()
      try {
        await this.saveTableColumns(2)
      } catch {
        this.$emit('change', this.displayColumns)
      }
      this.$emit('change', this.displayColumns)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333;
}
::v-deep {
  .el-checkbox {
    display: flex;
    align-items: center;
  }
}
.custom-table-header-popover {
  max-height: 700px !important;
  overflow-y: scroll;
}
.labelItem {
  width: 100px; /* 定义容器宽度 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis; /* 在文本结束后显示省略号 */
}
</style>
